import {AfterViewInit, Component, ElementRef, ViewChild} from '@angular/core';
import {MatPaginator, MatSort, PageEvent} from '@angular/material';
import 'rxjs/add/observable/of';
import {UserService} from '../../services/user.service';
import {User} from '../../model/Entities/User';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import {BaseListComponent} from '../../SharedModule/BaseListComponent/base-list.component';
import {UsersDataSource} from '../../model/DataSources/UsersDataSource';
import {SnackService} from '../../services/snack.service';
import {DialogService} from '../../services/dialog.service';
import {Router} from '@angular/router';
import {merge} from 'rxjs/observable/merge';
import {Subject} from 'rxjs/Subject';
import {SortInfo} from '../../model/Helpers/SortInfo';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import {Filter} from '../../model/Helpers/Filter';
import {CustomersDataSource} from '../../model/DataSources/CustomersDataSource';
import {CustomerService} from '../../services/customer.service';
import {Customer} from '../../model/Entities/Customer';
import {CustomerDeleteConfirmDialogComponent} from '../CustomerDeleteConfirmDialogComponent/customer-delete-confirm.dialog.component';
import {Pagination} from '../../model/Helpers/Pagination';
import {CustomersStatsDialogComponent} from '../CustomersStatsDialogComponent/customers-stats.dialog.component';

@Component({
    selector: 'customers-list',
    templateUrl: './customers-list.component.html',
    styleUrls: ['./customers-list.component.scss']
})

export class CustomersListComponent extends BaseListComponent implements AfterViewInit {
    tableColumns: String[] = ['name', 'contactPerson', 'contact', 'address', 'companyId', 'actions'];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('search') search: ElementRef;

    constructor(private customerService: CustomerService,
                private snackService: SnackService,
                private dialogService: DialogService,
                private router: Router) {
        super();

        this.dataSource = new CustomersDataSource(this.customerService);
    }

    ngAfterViewInit() {
        this.prepareDataLoading();
        this.reloadPage();

        // If the user changes the sort order, reset back to the first page.
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    }

    prepareDataLoading(): void {
        merge(
            this.paginator.page,
            this.sort.sortChange,
            Observable.fromEvent(this.search.nativeElement, 'keyup').debounceTime(150).distinctUntilChanged(),
            this.dataChangedEventSubject
        ).subscribe(() => {
            if (!this.dataSource) {
                return;
            }

            this.dataSource.loadPage(
                new Pagination(this.paginator.pageSize, this.paginator.pageSize * this.paginator.pageIndex),
                new SortInfo(this.sort.active, this.sort.direction),
                [
                    new Filter('search', this.search.nativeElement.value)
                ]);
        });
    }

    showCustomerDetail(customer: Customer): void {
        this.router.navigate([`/customer/${customer.id}`]);
    }

    delete(customer: Customer): void {
        this.dialogService.showDialog(CustomerDeleteConfirmDialogComponent, {
            'customer': customer
        }).afterClosed().subscribe((result) => {
            if (result) {
                this.customerService.delete(customer.id).subscribe(() => {
                    this.snackService.showSuccess(`Objednatel ${customer.name} byl smazán`);
                    this.reloadPage();
                });
            }
        });
    }

    openStatsDialog(): void {
        this.dialogService.showDialog(CustomersStatsDialogComponent, {})
            .afterClosed()
            .subscribe((result) => {
            });
    }

}




// WEBPACK FOOTER //
// /app/src/CustomersModule/CustomersListComponent/customers-list.component.ts